export const scoreTypeData = {
  vantage: {
    brackets: {
      Poor: 300,
      "Needs Work": 580,
      Fair: 640,
      Good: 700,
      Excellent: 750,
    },
  },
};

export const minScore = 300;
export const maxScore = 850;

export const totalScoreRange = maxScore - minScore;
export const SEEN_CA_PAUSE_REMINDER_COOKIE = "seen_ca_pause_reminder";
